import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

const theme = {
  primary: '#0F3565',
  secondary: '#B9CE1E',
  accent: '#2A8EA4',
  info: '#426483',
  background: '#e7eaeb',
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  dark: false,
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
